import React from 'react'
import PrefixComplete from '../PrefixComplete'
import PropTypes from 'prop-types'
import useGetResidentsByUnit from '../hooks/useGetResidentsByUnit'

export default function NamePicker(props) {
  const allOccupants = useGetResidentsByUnit(props.selectedPackageUnit)
  const residentNames = allOccupants.map(r => r.displayName)

  // NOTE: we're passing allowCustom here because that is the default behavior of the only component using this,
  // but it's not clear if that's the right behavior for all cases. If we need to change this, we can surface the same prop
  return <PrefixComplete options={residentNames} onChange={props.setName} value={props.name} allowCustom={true} />
}

NamePicker.propTypes = {
  selectedPackageUnit: PropTypes.string,
  name: PropTypes.string,
  setName: PropTypes.func.isRequired,
}
